// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  background: var(--vb-bg);
  color: var(--vb-text);
}

.auth-hero {
  display: none;
  background: var(--vb-hero);
  color: #fff;
  padding: 48px 40px;
  position: relative;
  overflow: hidden;
}

.auth-hero::after {
  content: '';
  position: absolute;
  width: 420px;
  height: 420px;
  right: -80px;
  bottom: -80px;
  border-radius: 50%;
  border: 48px solid rgba(251, 191, 36, 0.12);
  pointer-events: none;
}

.auth-hero-inner {
  position: relative;
  z-index: 1;
  max-width: 440px;
}

.auth-hero h1 {
  margin: 16px 0 8px;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-align: left;
  color: #fff;
  text-transform: none;
}

.auth-hero p {
  margin: 0 0 28px;
  font-size: 16px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.78);
}

.auth-features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-features li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.auth-features li span {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
}

.auth-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 48px;
  width: 100%;
  box-sizing: border-box;
}

.auth-brand-mobile {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 420px;
}

.auth-brand-mobile h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  text-align: left;
  color: var(--vb-text);
}

.auth-box {
  width: 100%;
  max-width: 420px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-lg);
  padding: 28px 24px;
  box-shadow: var(--vb-shadow);
  box-sizing: border-box;
}

.auth-box h2 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 800;
  text-align: left;
  color: var(--vb-text);
}

.auth-subtitle {
  margin: 0 0 20px;
  font-size: 14px;
  color: var(--vb-text-muted);
}

.auth-box form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.auth-box input {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  background: var(--vb-surface-2);
  color: var(--vb-text);
}

.auth-box input:focus {
  outline: none;
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.auth-box .submit-btn {
  width: 100%;
  margin-top: 6px;
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
  padding: 14px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 16px;
  font-weight: 750;
  box-shadow: 0 8px 20px rgba(234, 88, 12, 0.28);
}

.auth-box .submit-btn:hover { background: var(--vb-primary-hover); }

.auth-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.toggle-auth-btn,
.forgot-password-btn {
  background: none;
  border: none;
  color: var(--vb-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 650;
  padding: 6px;
}

.guest-btn {
  width: 100%;
  background: var(--vb-navy);
  color: #fff;
  border: none;
  border-radius: var(--vb-radius-sm);
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 700;
  margin-top: 4px;
}

body.night-mode .guest-btn {
  background: var(--vb-surface-2);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
}

.error-message {
  color: var(--vb-danger);
  background: var(--vb-danger-soft);
  padding: 10px 12px;
  border-radius: 10px;
  margin: 0 0 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.night-mode-toggle {
  margin-top: 20px;
}

.night-mode-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  padding: 10px 14px;
  border-radius: var(--vb-radius-pill);
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
}

/* Public matches */
.public-matches-section {
  width: 100%;
  max-width: 420px;
  margin-top: 28px;
}

.public-matches-section h3 {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 800;
  text-align: left;
}

.public-match-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.public-match-card {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 12px;
  width: 100%;
  text-align: left;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
  padding: 12px 14px;
  cursor: pointer;
  color: inherit;
  box-shadow: var(--vb-shadow-sm);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.public-match-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--vb-shadow);
}

.pmc-teams {
  font-size: 14px;
  font-weight: 650;
  grid-column: 1;
}

.pmc-score {
  grid-column: 2;
  grid-row: 1 / span 2;
  align-self: center;
  font-family: var(--vb-font-score);
  font-size: 22px;
  font-weight: 800;
}

.pmc-meta {
  grid-column: 1;
  font-size: 12px;
  color: var(--vb-text-muted);
}

.public-matches-container {
  background: transparent;
  padding: 0;
}

.public-matches-table {
  width: 100%;
  border-collapse: collapse;
}

.public-matches-table th,
.public-matches-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid var(--vb-border);
  font-size: 14px;
}

.view-more-btn {
  width: 100%;
  margin-top: 10px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  padding: 10px 16px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-weight: 650;
}

.no-matches {
  text-align: center;
  color: var(--vb-text-muted);
  font-size: 14px;
}

.winner { font-weight: 800; }

.clickable-row { cursor: pointer; }

.public-match-detail {
  width: 100%;
  max-width: 720px;
}

.match-detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  padding: 10px 14px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 650;
}

.match-detail-header h2 {
  margin: 0;
  font-size: 20px;
}

.match-info-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: var(--vb-shadow-sm);
}

.match-teams {
  text-align: center;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 8px;
}

.match-teams .vs {
  color: var(--vb-text-muted);
  font-weight: 600;
  margin: 0 8px;
}

.match-score {
  text-align: center;
  font-family: var(--vb-font-score);
  font-size: 48px;
  font-weight: 800;
  margin-bottom: 16px;
}

.winner-score { color: var(--vb-primary); }

.match-metadata {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  font-size: 14px;
}

.match-note {
  grid-column: 1 / -1;
  background: var(--vb-surface-2);
  padding: 10px 12px;
  border-radius: 10px;
  border-left: 4px solid var(--vb-primary);
}

.score-chart {
  margin: 20px 0;
  background: var(--vb-surface);
  border-radius: var(--vb-radius);
  padding: 16px;
  border: 1px solid var(--vb-border);
}

.no-chart-data {
  text-align: center;
  color: var(--vb-text-muted);
}

@media (min-width: 960px) {
  .auth-container {
    grid-template-columns: minmax(320px, 1.05fr) minmax(420px, 1fr);
  }
  .auth-hero {
    display: flex;
    align-items: center;
    min-height: 100vh;
  }
  .auth-brand-mobile { display: none; }
  .auth-panel {
    justify-content: center;
    padding: 40px 32px;
  }
}

@media (max-width: 768px) {
  .match-metadata { grid-template-columns: 1fr; }
  .match-detail-header { flex-direction: column; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,8BAA8B,mCAAmC,EAAE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,UAAU,gBAAgB,EAAE;;AAE5B,iBAAiB,eAAe,EAAE;;AAElC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB,wBAAwB,EAAE;;AAE1C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;EACA,qBAAqB,aAAa,EAAE;EACpC;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB,0BAA0B,EAAE;EAC9C,uBAAuB,sBAAsB,EAAE,uBAAuB,EAAE;AAC1E","sourcesContent":[".auth-container {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 1fr;\n  background: var(--vb-bg);\n  color: var(--vb-text);\n}\n\n.auth-hero {\n  display: none;\n  background: var(--vb-hero);\n  color: #fff;\n  padding: 48px 40px;\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-hero::after {\n  content: '';\n  position: absolute;\n  width: 420px;\n  height: 420px;\n  right: -80px;\n  bottom: -80px;\n  border-radius: 50%;\n  border: 48px solid rgba(251, 191, 36, 0.12);\n  pointer-events: none;\n}\n\n.auth-hero-inner {\n  position: relative;\n  z-index: 1;\n  max-width: 440px;\n}\n\n.auth-hero h1 {\n  margin: 16px 0 8px;\n  font-size: 36px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  text-align: left;\n  color: #fff;\n  text-transform: none;\n}\n\n.auth-hero p {\n  margin: 0 0 28px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.auth-features {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-features li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.auth-features li span {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.auth-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px 48px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.auth-brand-mobile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 420px;\n}\n\n.auth-brand-mobile h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  text-align: left;\n  color: var(--vb-text);\n}\n\n.auth-box {\n  width: 100%;\n  max-width: 420px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-lg);\n  padding: 28px 24px;\n  box-shadow: var(--vb-shadow);\n  box-sizing: border-box;\n}\n\n.auth-box h2 {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-weight: 800;\n  text-align: left;\n  color: var(--vb-text);\n}\n\n.auth-subtitle {\n  margin: 0 0 20px;\n  font-size: 14px;\n  color: var(--vb-text-muted);\n}\n\n.auth-box form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-field label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.auth-box input {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 12px 14px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n}\n\n.auth-box input:focus {\n  outline: none;\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.auth-box .submit-btn {\n  width: 100%;\n  margin-top: 6px;\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n  padding: 14px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 750;\n  box-shadow: 0 8px 20px rgba(234, 88, 12, 0.28);\n}\n\n.auth-box .submit-btn:hover { background: var(--vb-primary-hover); }\n\n.auth-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.toggle-auth-btn,\n.forgot-password-btn {\n  background: none;\n  border: none;\n  color: var(--vb-primary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 650;\n  padding: 6px;\n}\n\n.guest-btn {\n  width: 100%;\n  background: var(--vb-navy);\n  color: #fff;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  padding: 12px 16px;\n  font-size: 15px;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\nbody.night-mode .guest-btn {\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n}\n\n.error-message {\n  color: var(--vb-danger);\n  background: var(--vb-danger-soft);\n  padding: 10px 12px;\n  border-radius: 10px;\n  margin: 0 0 8px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.night-mode-toggle {\n  margin-top: 20px;\n}\n\n.night-mode-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  padding: 10px 14px;\n  border-radius: var(--vb-radius-pill);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n/* Public matches */\n.public-matches-section {\n  width: 100%;\n  max-width: 420px;\n  margin-top: 28px;\n}\n\n.public-matches-section h3 {\n  margin: 0 0 12px;\n  font-size: 15px;\n  font-weight: 800;\n  text-align: left;\n}\n\n.public-match-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.public-match-card {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px 12px;\n  width: 100%;\n  text-align: left;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n  padding: 12px 14px;\n  cursor: pointer;\n  color: inherit;\n  box-shadow: var(--vb-shadow-sm);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.public-match-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--vb-shadow);\n}\n\n.pmc-teams {\n  font-size: 14px;\n  font-weight: 650;\n  grid-column: 1;\n}\n\n.pmc-score {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  align-self: center;\n  font-family: var(--vb-font-score);\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.pmc-meta {\n  grid-column: 1;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n}\n\n.public-matches-container {\n  background: transparent;\n  padding: 0;\n}\n\n.public-matches-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.public-matches-table th,\n.public-matches-table td {\n  padding: 8px 10px;\n  text-align: left;\n  border-bottom: 1px solid var(--vb-border);\n  font-size: 14px;\n}\n\n.view-more-btn {\n  width: 100%;\n  margin-top: 10px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  padding: 10px 16px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-weight: 650;\n}\n\n.no-matches {\n  text-align: center;\n  color: var(--vb-text-muted);\n  font-size: 14px;\n}\n\n.winner { font-weight: 800; }\n\n.clickable-row { cursor: pointer; }\n\n.public-match-detail {\n  width: 100%;\n  max-width: 720px;\n}\n\n.match-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  padding: 10px 14px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.match-detail-header h2 {\n  margin: 0;\n  font-size: 20px;\n}\n\n.match-info-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 24px;\n  margin-bottom: 20px;\n  box-shadow: var(--vb-shadow-sm);\n}\n\n.match-teams {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n.match-teams .vs {\n  color: var(--vb-text-muted);\n  font-weight: 600;\n  margin: 0 8px;\n}\n\n.match-score {\n  text-align: center;\n  font-family: var(--vb-font-score);\n  font-size: 48px;\n  font-weight: 800;\n  margin-bottom: 16px;\n}\n\n.winner-score { color: var(--vb-primary); }\n\n.match-metadata {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.match-note {\n  grid-column: 1 / -1;\n  background: var(--vb-surface-2);\n  padding: 10px 12px;\n  border-radius: 10px;\n  border-left: 4px solid var(--vb-primary);\n}\n\n.score-chart {\n  margin: 20px 0;\n  background: var(--vb-surface);\n  border-radius: var(--vb-radius);\n  padding: 16px;\n  border: 1px solid var(--vb-border);\n}\n\n.no-chart-data {\n  text-align: center;\n  color: var(--vb-text-muted);\n}\n\n@media (min-width: 960px) {\n  .auth-container {\n    grid-template-columns: minmax(320px, 1.05fr) minmax(420px, 1fr);\n  }\n  .auth-hero {\n    display: flex;\n    align-items: center;\n    min-height: 100vh;\n  }\n  .auth-brand-mobile { display: none; }\n  .auth-panel {\n    justify-content: center;\n    padding: 40px 32px;\n  }\n}\n\n@media (max-width: 768px) {\n  .match-metadata { grid-template-columns: 1fr; }\n  .match-detail-header { flex-direction: column; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
